export const PublicDocuments = {
  PRIVACY_POLICY: "/documents/privacy.pdf",
  TERMS_OF_SERVICE: "/documents/tos.pdf",
  SALES_TERMS: "/documents/sales-terms.pdf",
  EXAMPLE_DUE_DILIGENCE_REPORT: "/documents/callirius-demo-report.pdf",
}
